import React from 'react';
export function StickyTopBar() {
  return <div className="fixed top-0 left-0 right-0 z-50 bg-[#E8440A] text-white py-3 px-4 text-center overflow-hidden pt-[7px] pb-[7px] pl-[14px] pr-[14px]" data-id="element-206">
      <div className="animate-marquee whitespace-nowrap inline-block" data-id="element-207">
        <span className="text-sm md:text-base font-semibold" data-id="element-208">
          🔥 OFERTA ESPECIAL · SOLO POR HOY · TIEMPO LIMITADO ⭐ +2.800 familias
          ya lo tienen
        </span>
      </div>
    </div>;
}